export class TravelBankSignInRequestObj{
    constructor()
    {
        this.requestObj={
            "userId": null,
            "password": null,
            "cookieSabreDataRequest": null
        }
    }
}